import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../service/user.service';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-zoom-oauth',
  templateUrl: './zoom-oauth.component.html',
  styleUrls: ['./zoom-oauth.component.css']
})
export class ZoomOAuthComponent implements OnInit {
  zoomPath: any;
  authCode: any;
  headers: any;
  successStr: any;
  encryptSecretKey: any;
  zoomUrl: any = 'https://zoom.us/oauth/authorize?client_id=EfRTPmPQQxWFx8mFAb9mlA&response_type=code&redirect_uri=https%3A%2F%2Flocalhost%2Fzoom-service%2Fzoom%2FauthZoom';
  constructor(private userService: UserService, private http: HttpClient, private sanitizier: DomSanitizer, private activatedroute: ActivatedRoute) {
    this.headers = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8')
      //.set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");

    this.activatedroute.queryParams.subscribe(
      params => {

        this.authCode = params['code'];

      });
    this.encryptSecretKey = "AGORA";

    //var webconfType = localStorage.getItem('meetType')
    var webconfType = 'Zoom'
    var webConfEmail = this.encryptData(localStorage.getItem('email'))
    //var webConfEmail = 'kala.lakshmi@gmail.com'
    var webConfAuthCode = this.encryptData(this.authCode)
    var webConfClientId = this.encryptData(localStorage.getItem('clientId'))
    //var webConfClientId = "clientId"
    var webConfSecretId = this.encryptData(localStorage.getItem('secretId'))
    //var webConfSecretId = 'sceretId'
    var createdBy = localStorage.getItem('createdBy');
    var createdOn = ''
    if (this.authCode != undefined && this.authCode != null) {
      var reqJSON = {
        "pk_userid": localStorage.getItem('userId'),
        "orgCode": localStorage.getItem('orgCode'),
        "webconfType": webconfType,
        "webConfEmail": webConfEmail,
        "webConfAuthCode": webConfAuthCode,
        "webConfClientId": webConfClientId,
        "webConfSecretId": webConfSecretId,
        "createdBy": createdBy,
        "createdOn": createdOn
      }

      this.userService.saveUserWebConf(reqJSON).subscribe(response => { console.log(response) });
      //this.callToken(this.authCode);
      this.successStr = "You are successfully connected with Zoom";

    }



  }
  callToken(authCode: any) {


    const formData = {
      grant_type: 'authorization_code',
      code: authCode,
      redirect_uri: 'https://localhost/agora/zoomOAuth'

    };

    let auth_token = Buffer.from('EfRTPmPQQxWFx8mFAb9mlA' + ':' + 'vhmLrWYKMYxqxMVvTF97lEe83sbS2c9Y').toString('base64');

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Basic ${auth_token}`,
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,POST,PUT,DELETE'
    });

    const requestOptions = { headers: headers, withCredentials: true };

    this.http.post("https://zoom.us/oauth/token", formData, requestOptions).subscribe((rs: any) => {

    })
  }
  ngOnInit(): void {
    //this.zoomPath = this.sanitizier.bypassSecurityTrustResourceUrl(this.zoomUrl);

  }
  encryptData(data: any) {

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();
    } catch (e) {

    }
    return data;

  }

  decryptData(data: any) {

    try {
      const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {

    }
  }

}
